import React, { useMemo, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { MainContainer } from './styles';
import { FilesListing } from './FilesListing';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useIdmsUploadsQuery } from '@/__generated__/graphql';
import { UploadFile } from './UploadFile';
import { PageLoader } from '@/components/shared/PageLoader';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';

export const IDMSContainer = () => {
  const [fileTypeModal, setFileTypeModal] = useState<boolean>(false);
  const [templatesModal, setTemplatesModal] = useState<boolean>(false);
  const fileInputReference = useRef<HTMLInputElement | undefined>(undefined);
  const structureId = useGetStructureId();
  const { data: filesData, loading } = useIdmsUploadsQuery({
    variables: { structureId },
  });

  const showListing = useMemo(() => {
    return filesData?.idmsUploads?.length !== 0;
  }, [filesData?.idmsUploads?.length]);

  if (loading) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <AccessGuard structureId={structureId} feature="idms">
      <MainContainer>
        {showListing && (
          <FilesListing
            filesData={filesData}
            structureId={structureId}
            setTemplatesModal={setTemplatesModal}
            fileInputReference={fileInputReference}
          />
        )}
        <UploadFile
          showListing={showListing}
          fileTypeModal={fileTypeModal}
          templatesModal={templatesModal}
          setTemplatesModal={setTemplatesModal}
          setFileTypeModal={setFileTypeModal}
          fileInputReference={fileInputReference}
        />
      </MainContainer>
    </AccessGuard>
  );
};
